/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { FIPApiService } from '../http/fip.api.service';
import { Injectable } from '@angular/core';
import { IpGroupApiService, NetworkingApiService } from '../http';

/**
 *
 */
@Injectable()
export class NetworkInterfaceResolver {
    constructor(
        private networkingApiService: NetworkingApiService
    ) {
    }

    public resolve(): any {
        return this.networkingApiService.getInterfaces();
    }
}

/**
 *
 */
@Injectable()
export class FloatingIPGroupsResolver {
    constructor(
        private ipGroupApiService: IpGroupApiService,
    ) {
    }

    public resolve(): any {
        return this.ipGroupApiService.getGroups();
    }
}

/**
 *
 */
@Injectable()
export class FloatingIPsResolver {
    constructor(
        private fipApiService: FIPApiService
    ) {
    }

    public resolve(): any {
        return this.fipApiService.getFloatingIPs();
    }
}
